export default class KmklabsUtil {
  static isPremium(){
    return (KmklabsUtil.video().premium || null) == "true";
  }

  static videoId(){
    return KmklabsUtil.video().id || null;
  }

  //NOTE: the source could be boolean or url, please see InteractionsController#show_stream_livestreaming
  static videoSource(){
    let source = KmklabsUtil.video().source;
    if(source == false){
      return source;
    }
    return source || null;
  }

  static isLiveChatEnabled(){
    return (KmklabsUtil.live().chatEnabled || null) == "true";
  }

  static isLiveHasStreamRight(){
    return (KmklabsUtil.live().streamRight || null) == "true";
  }

  static isPremierAccessibleSource(){
    let premier = KmklabsUtil.isPremium();
    let source = KmklabsUtil.videoSource();
    return premier && (source !== false && source !== null);
  }

  static video(){
    return KmklabsUtil.kmklabs().video || {};
  }

  static live(){
    return KmklabsUtil.kmklabs().live || {};
  }

  static kmklabs(){
    return window.kmklabs || {};
  }
}
